import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const get_files_list = (page, per_page, name, status) => {
  return api.post(`${ApiEndpointConstants.GETMODELLIST}`, {
    page,
    per_page,
    name,
    status,
  });
};
